import { apiHttp } from "../axiosApi.js";
import { truckCharacteristic } from "../config/apiRoute.js";

export const postTruckCharacteristicAPI = (body) =>
  apiHttp("POST", `${truckCharacteristic}`, body);

export const getTruckCharacteristicByTruckIdAPI = (id) =>
  apiHttp("GET", `${truckCharacteristic}/${id}`);

export const getTruckCharacteristicById = (id) =>
  apiHttp("GET", `${truckCharacteristic}/charac/${id}`);

export const getTruckCharacteristicAPI = () =>
  apiHttp("GET", `${truckCharacteristic}`);

export const patchCharacteristicById = (id, body) =>
  apiHttp("PATCH", `${truckCharacteristic}/${id}`, body);

export const patchCharacteristicStatus = (id, body) => {
  return apiHttp("PATCH", `${truckCharacteristic}/status/${id}`, body);
};

export const getTruckCharacteristicsAPI = (limit = 5, from = 0, all = false) =>
  apiHttp(
    "GET",
    `${truckCharacteristic}?limit=${limit}&from=${from}&all=${all}`
  );
